module.exports = __webpack_public_path__ + "static/img/no.59fc5b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no.png
// module id = 8vHv
// module chunks = 1